import { render, staticRenderFns } from "./ErrorBar.vue?vue&type=template&id=535a7bc0&scoped=true&"
import script from "./ErrorBar.vue?vue&type=script&lang=ts&"
export * from "./ErrorBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535a7bc0",
  null
  
)

export default component.exports